import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    token: null,
    role: null,
    users: null,
  });

  const login = ({ token, role, users }) => {
    setAuth({
      token,
      role,
      users,
    });
  };

  const logout = () => {
    setAuth({
      token: null,
      role: null,
      users: null,
    });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
